import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import confetti from "canvas-confetti";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
// dayjs.extend(customParseFormat);
import {
    Button,
    Card,
    Col,
    Form,
    Modal,
    Row,
    Select,
    Spin,
    Typography,
    Space,
    DatePicker,
    Input,
    message,
    Divider,
} from "antd";
import {
    FaUser,
    FaUniversity,
    FaMapMarkerAlt,
    FaGraduationCap,
    FaFileAlt,
    FaFilePdf,
} from "react-icons/fa";
import {
    CheckCircleOutlined,
    PlusOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../../context/AuthContext";
import Loginheader from "../../components/loginheader/Loginheader";
import Icon from "../../assests/sidebar-icon.png";
import Preview from "../../assests/preview.png";
import { StopOutlined } from "@ant-design/icons";


const { Option } = Select;
const { Title } = Typography;
const { TextArea } = Input

const ConvertEmployee = ({ candidateid, authData, backUrl }) => {
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [employees, setEmployees] = useState([]);


    const [formData, setFormData] = useState({
        organisation: "",
        department: "",
        designation: "",
        reporting_to: "",
        total_casual_leave: 0.0,
        total_earned_leave: 0.0,
        total_sick_leave: 0.0,
    });
    const [loading, setLoading] = useState(false);
    const [showConvertModal, setShowConvertModal] = useState(false);


    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/?organisation=${v}`, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            setDepartments(res.data.results || []);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
            toast.error("Failed to fetch departments");
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            setOrganizations(res.data.results || []);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
            toast.error("Failed to fetch organizations");
        }
    };

    const fetchDesignations = async (departmentId) => {
        if (!departmentId) {
            setDesignations([]);
            return;
        }
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/designations/?department=${departmentId}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setDesignations(res.data.results || []);
        } catch (err) {
            console.error("Error fetching designations:", err);
            toast.error("Failed to fetch designations");
        }
    };

    const fetchEmployees = async (designationId) => {
        if (!designationId) {
            setEmployees([]);
            return;
        }
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/employees/?designation=${designationId}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setEmployees(res.data.results || []);
        } catch (err) {
            console.error("Error fetching employees:", err);
            toast.error("Failed to fetch employees");
        }
    };

    useEffect(() => {
        fetchOrganizations();
        // fetchDepartments();
    }, [authData, backUrl]);

    const handleChange = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (name === "department") {
            fetchDesignations(value);
            setFormData((prev) => ({ ...prev, designation: "", reporting_to: "" }));
            setEmployees([]);

        } else if (name === "designation") {
            fetchEmployees(value);
            setFormData((prev) => ({ ...prev, reporting_to: "" }));
        }
        else if (name === "organisation") {
            fetchDepartments(value)
        }
    };

    const onClickSubmit = async () => {
        setLoading(true);
        try {

            // formData.total_casual_leave = parseFloat(formData.total_casual_leave)
            // formData.total_sick_leave = parseFloat(formData.total_sick_leave)
            // formData.total_earned_leave = parseFloat(formData.total_earned_leave)

            const res = await axios.patch(
                `${backUrl}/api/emp/convert-to-employee/${candidateid}/`,
                formData,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );

            toast.success("Employee converted successfully!", {
                position: "top-center",
                autoClose: 2000,
            });

            const duration = 3000;
            const animationEnd = Date.now() + duration;
            const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 2000 };

            const interval = setInterval(() => {
                const timeLeft = animationEnd - Date.now();
                if (timeLeft <= 0) return clearInterval(interval);

                const particleCount = 50 * (timeLeft / duration);
                confetti({
                    ...defaults,
                    particleCount,
                    origin: { x: Math.random(), y: Math.random() - 0.2 },
                    colors: [
                        "#ff0a54",
                        "#ffff47",
                        "#72ff70",
                        "#85efff",
                        "#d2b1fb",
                        "#f9c1be",
                        "#ffffff",
                        "#ffd700",
                    ],
                });
                confetti({
                    ...defaults,
                    particleCount: 20,
                    scalar: 0.6,
                    shapes: ["star"],
                    origin: { x: Math.random(), y: Math.random() - 0.2 },
                    colors: ["#ffffff", "#ffd700"],
                });
            }, 200);

            setTimeout(() => setShowConvertModal(false), duration);
        } catch (err) {
            console.error("Error converting employee:", err);
            const errorMessage =
                err.response?.data?.message ||
                err.response?.data?.error ||
                "Conversion failed. Please check all fields.";
            toast.error(errorMessage, { position: "top-center", autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <center>

                <Button
                    type="primary"
                    onClick={() => setShowConvertModal(true)}
                    icon={<CheckCircleOutlined />}
                    style={{
                        background: "linear-gradient(90deg, #28a745, #20c997)",
                        border: "none",
                        borderRadius: "6px",
                        fontSize: "15px",
                        fontWeight: 500,
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                        margin: "10px",
                    }}
                    aria-label="Convert to Employee"
                >
                    Convert Employee
                </Button>
            </center>


            <Modal
                open={showConvertModal}
                onCancel={() => setShowConvertModal(false)}
                footer={null}
                title="Convert to Employee"
                width={600}
                centered
            >
                <Spin spinning={loading} tip="Converting...">
                    <Form layout="vertical">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item label="Organization" required>
                                    <Select
                                        placeholder="-- Select --"
                                        value={formData.organisation}
                                        onChange={(val) => handleChange("organisation", val)}
                                        style={{ width: "100%" }}
                                    >
                                        <Option value="">-- Select --</Option>
                                        {organizations.map((org) => (
                                            <Option key={org.id} value={org.id}>
                                                {org.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Department" required>
                                    <Select
                                        placeholder="-- Select --"
                                        value={formData.department}
                                        onChange={(val) => handleChange("department", val)}
                                        style={{ width: "100%" }}
                                    >
                                        <Option value="">-- Select --</Option>
                                        {departments.map((dept) => (
                                            <Option key={dept.id} value={dept.id}>
                                                {dept.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Designation" required>
                                    <Select
                                        placeholder="-- Select --"
                                        value={formData.designation}
                                        onChange={(val) => handleChange("designation", val)}
                                        disabled={!formData.department}
                                        style={{ width: "100%" }}
                                    >
                                        <Option value="">-- Select --</Option>
                                        {designations.map((des) => (
                                            <Option key={des.id} value={des.id}>
                                                {des.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Reporting To">
                                    <Select
                                        placeholder="-- Select --"
                                        value={formData.reporting_to}
                                        onChange={(val) => handleChange("reporting_to", val)}
                                        disabled={!formData.designation}
                                        style={{ width: "100%" }}
                                    >
                                        <Option value="">-- Select --</Option>
                                        {employees.map((emp) => (
                                            <Option key={emp.id} value={emp.emp_code}>
                                                {emp.first_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Casual Leave" required>
                                    <Input
                                        type="number"
                                        value={formData.total_casual_leave}
                                        onChange={(e) => handleChange("total_casual_leave", e.target.value)}
                                        min={0}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Item>
                            </Col>

                            {/*<Col span={8}>
                                <Form.Item label="Earned Leave" required>
                                    <Input
                                        type="number"
                                        value={formData.total_earned_leave}
                                        onChange={(e) => handleChange("total_earned_leave", e.target.value)}
                                        min={0}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Item>
                            </Col> */}

                            <Col span={8}>
                                <Form.Item label="Sick Leave" required>
                                    <Input
                                        type="number"
                                        value={formData.total_sick_leave}
                                        onChange={(e) => handleChange("total_sick_leave", e.target.value)}
                                        min={0}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <Button
                                type="primary"
                                onClick={onClickSubmit}
                                loading={loading}
                                icon={<CheckCircleOutlined />}
                                style={{ background: "#1890ff", borderColor: "#1890ff" }}
                                aria-label="Submit Conversion"
                            >
                                Convert to Employee
                            </Button>
                        </div>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
};

const ViewProfile = ({ candidateid }) => {
    const [preOnboardData, setPreOnboardData] = useState({});
    const [fileData, setFileData] = useState({});
    const [showSideBar, setShowSideBar] = useState(false);
    const [activeSection, setActiveSection] = useState("personal");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [onboardRemarks, setOnboardRemarks] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [docUrl, setDocUrl] = useState("");
    const [docType, setDocType] = useState("");
    const [loading, setLoading] = useState(false);
    const [addEducation, setAddEducation] = useState(1);
    const [addCareer, setAddCareer] = useState(1);
    const [addReference, setAddReference] = useState(1);
    const [addActivity, setAddActivity] = useState(1);
    const [errors, setErrors] = useState({});

    const [blockListReason, setBlockListReason] = useState("")


    const { authData, backUrl } = useContext(AuthContext);
    const { cid } = useParams();
    const effectiveCandidateId = candidateid || cid;

    const toggleEditMode = () => {
        if (isEditMode) {
            setIsEditMode(false);
            fetchCandidateData();
        } else {
            setIsEditMode(true);
        }
    };

    const saveChanges = async () => {
        if (!validateForm()) {
            message.error("Please fill all required fields");
            return;
        }
        try {
            await submitFormData();
            setIsEditMode(false);
            message.success("Changes saved successfully!");
        } catch (error) {
            message.error("Failed to save changes");
        }
    };

    const handleOpen = (documentUrl) => {
        if (!documentUrl) return;
        const fileExtension = documentUrl.split(".").pop().toLowerCase();
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

        if (imageExtensions.includes(fileExtension)) {
            // Show modal only for images
            setDocUrl(documentUrl);
            setDocType("image");
            setShowModal(true);
        } else {
            // Trigger direct download for non-image files
            const link = document.createElement("a");
            link.href = documentUrl;
            link.download = documentUrl.split("/").pop(); // extract file name
            link.target = "_blank"; // optional, in case browser handles pdf/doc directly
            link.click();
        }
    };

    const handlePreview = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/preview-offer/${effectiveCandidateId}/`,
                {
                    responseType: "blob",
                    headers: { Authorization: `Bearer ${authData?.access}` },
                }
            );
            const url = URL.createObjectURL(res.data);
            window.open(url, "_blank");
            setTimeout(() => URL.revokeObjectURL(url), 100000);
        } catch (err) {
            console.error("Error previewing offer letter:", err);
            toast.error("Failed to preview offer letter");
        } finally {
            setLoading(false);
        }
    };

    const submitFormData = async () => {
        if (!validateForm()) {
            throw new Error("Form validation failed");
        }
        setIsSubmitting(true);

        try {
            const formData = new FormData();

            // keys to exclude from formData
            const excludeKeys = [
                "HSC_diploma_ITI",
                "PG_Phd",
                "SSLC",
                "aadhar_card_copy",
                "appointment_letter",
                "bank_account_details",
                "covid_certificate",
                "degree_certificate",
                "last_three_month_payslip",
                "offer_letter",
                "pan_card_copy",
                "previous_experience_letter",
                "releiving_letter",
                "last_three_months_account_statement",
            ];

            // append preOnboardData (excluding above keys)
            Object.entries(preOnboardData).forEach(([key, value]) => {
                if (
                    !excludeKeys.includes(key) && // skip unwanted keys
                    value != null &&
                    value !== ""
                ) {
                    formData.append(
                        key,
                        Array.isArray(value) || typeof value === "object"
                            ? JSON.stringify(value)
                            : value
                    );
                }
            });

            // append fileData (excluding above keys)
            Object.entries(fileData).forEach(([key, value]) => {
                if (!excludeKeys.includes(key) && value) {
                    formData.append(key, value);
                }
            });

            const res = await axios.put(
                `${backUrl}/api/emp/candidate-preonboarding-form/${preOnboardData.submission_token}/`,
                formData,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );

            toast.success(res.data.message || "Form submitted successfully!");
        } catch (error) {
            const errMsg =
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Error submitting form. Please try again.";
            console.error("Error submitting form:", errMsg);
            toast.error(errMsg, { position: "top-center", autoClose: 3000 });
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    };


    const fetchCandidateData = async () => {
        if (!effectiveCandidateId) {
            console.warn("candidateid is missing");
            toast.error("Candidate ID is missing");
            return;
        }
        setLoading(true);
        try {
            const url = `${backUrl}/api/emp/candidate/?candidate_id=${effectiveCandidateId}`;
            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });
            const candidateData = res.data.results?.[0] || {};
            setPreOnboardData(candidateData);
            setAddEducation(candidateData.education_history?.length || 1);
            setAddCareer(candidateData.career_history?.length || 1);
            setAddReference(candidateData.reference_history?.length || 1);
            setAddActivity(candidateData.extra_curricular_activity?.length || 1);
        } catch (error) {
            const errMsg =
                error.response?.data?.detail ||
                "Failed to fetch candidate data. Please try again.";
            console.error("Error fetching candidate:", error);
            toast.error(errMsg, { position: "top-center", autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCandidateData();
    }, [effectiveCandidateId, authData, backUrl]);

    const handleEducationChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };
            if (!updatedData.education_history) {
                updatedData.education_history = [];
            }
            if (!updatedData.education_history[index]) {
                updatedData.education_history[index] = {};
            }
            updatedData.education_history[index][field] = value;
            return updatedData;
        });
    };

    const handleCareerChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };
            if (!updatedData.career_history) {
                updatedData.career_history = [];
            }
            if (!updatedData.career_history[index]) {
                updatedData.career_history[index] = {};
            }
            updatedData.career_history[index][field] = value;
            return updatedData;
        });
    };

    const handleReferenceChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };
            if (!updatedData.reference_history) {
                updatedData.reference_history = [];
            }
            if (!updatedData.reference_history[index]) {
                updatedData.reference_history[index] = {};
            }
            updatedData.reference_history[index][field] = value;
            return updatedData;
        });
    };

    // const handleActivityChange = (index, field, value) => {
    //     setPreOnboardData((prev) => {
    //         const updatedData = { ...prev };
    //         if (!updatedData.extra_curricular_activity) {
    //             updatedData.extra_curricular_activity = [];
    //         }
    //         if (!updatedData.extra_curricular_activity[index]) {
    //             updatedData.extra_curricular_activity[index] = {};
    //         }
    //         updatedData.extra_curricular_activity[index][field] = value;
    //         return updatedData;
    //     });
    // };

    const handleChildChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };
            if (!updatedData.children) {
                updatedData.children = [];
            }
            if (!updatedData.children[index]) {
                updatedData.children[index] = {};
            }
            updatedData.children[index][field] = value;
            return updatedData;
        });
    };

    const validateForm = () => {
        const requiredFields = [
            'initial', 'first_name', 'last_name', 'mobile_number', 'email_id',
            'aadhaar_card_number', 'pan_card_number', 'date_of_birth', 'place_of_birth', 'mother_tongue',
            'gender', 'blood_group', 'emergency_contact_person', 'emergency_contact_number',
            'bank_account_number', 'ifsc_code', 'uan_number', 'branch_name',
            'address_for_communication', 'area', 'city', 'state', 'country', 'pincode', 'height', 'weight', 'religion',
            'permanent_address_for_communication', 'permanent_area', 'permanent_city', 'permanent_state', 'permanent_country', 'permanent_pincode'
        ];

        const newErrors = {};

        requiredFields.forEach(field => {
            if (!preOnboardData[field] || preOnboardData[field].toString().trim() === '') {
                newErrors[field] = 'This field is required';
            }
        });

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            const missingFields = Object.keys(newErrors)
                .map(f => f.replace(/_/g, " "))
                .join(", ");
            alert(`Please fill the following required fields:\n\n${missingFields}`);
        }

        return Object.keys(newErrors).length === 0;
    };

    const handleBlockList = async (id) => {
        const res = await axios.patch(`${backUrl}/api/emp/candidates/${id}/blocklist/`, {
            status: "Blocklisted",
            reason: blockListReason
        }, {
            headers: {
                Authorization: `Bearer ${authData?.access}`
            }
        })
        alert("Candidate BlockListed Successfully!")
    }

    const handleSectionSelect = (section) => {
        setActiveSection(section);
        setShowSideBar(false);
    };

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === 'file') {
            setFileData((prev) => ({
                ...prev,
                [name]: files[0]
            }));
        } else {
            setPreOnboardData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };

    return (
        <>
            {/* <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                closeButton={true}
            /> */}

            {/* <Loginheader /> */}
            {/* <a className="mb-2 ms-3 bg-light" onClick={() => setShowSideBar(!showSideBar)}>
                <img
                    id="show-icon1"
                    className={showSideBar ? "rotate mb-2 ms-3" : "mb-2 ms-3"}
                    src={Icon}
                    alt="Toggle Sidebar"
                />
            </a> */}
            {/* Sidebar */}
            {showSideBar && (
                <div id="sidebar-view" className={showSideBar ? "active" : ""}>
                    <div className="sidebar-content">
                        <ul>
                            <li onClick={() => handleSectionSelect("personal")}>Personal Details</li>
                            <li onClick={() => handleSectionSelect("bank")}>Bank Details</li>
                            <li onClick={() => handleSectionSelect("address")}>Address Details</li>
                            <li onClick={() => handleSectionSelect("education")}>Education Details</li>
                            <li onClick={() => handleSectionSelect("documents")}>Documents</li>
                        </ul>
                    </div>
                </div>
            )}



            {/* Top buttons for large screens */}
            <div id="show-container1" className="container mt-4 mb-4">
                <div className="row justify-content-center">
                    {[
                        { key: "personal", label: "Personal Details", icon: <FaUser /> },
                        { key: "bank", label: "Bank Details", icon: <FaUniversity /> },
                        { key: "address", label: "Address Details", icon: <FaMapMarkerAlt /> },
                        { key: "education", label: "Education Details", icon: <FaGraduationCap /> },
                        { key: "documents", label: "Documents", icon: <FaFileAlt /> },

                    ].map((item) => (
                        <div className="col text-center position-relative" key={item.key}>
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: activeSection === item.key ? "#0d6efd" : "#e9ecef",
                                    color: activeSection === item.key ? "#fff" : "#6c757d",
                                    zIndex: 1,
                                    cursor: "pointer"
                                }}
                                onClick={() => setActiveSection(item.key)}
                            >
                                {item.icon}
                            </div>
                            <small
                                className={activeSection === item.key ? "text-primary fw-bold" : "text-muted"}
                                style={{ cursor: "pointer" }}
                                onClick={() => setActiveSection(item.key)}
                            >
                                {item.label}
                            </small>
                        </div>
                    ))}
                </div>
                <hr />
            </div>

            <center>
                <p style={{ color: "#d32f2f", marginBottom: "16px" }}>
                    * Indicates required fields
                </p>
            </center>

            {/* Section rendering */}
            <div className="section-content">

                {
                    !isEditMode && (
                        <center>
                            <Button
                                className="m-3"
                                onClick={toggleEditMode}
                                style={{ background: "#0e497b", color: "#ffffffff" }}
                                aria-label="Edit Profile"
                            >
                                Edit
                            </Button>
                        </center>
                    )
                }

                {isEditMode && (
                    <center>
                        <div style={{ margin: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
                            <Button
                                onClick={saveChanges}
                                loading={isSubmitting}
                                style={{ background: "#0e497b", color: "#ffffffff" }}
                                aria-label="Save Changes"
                            >
                                Save
                            </Button>
                            <Button
                                onClick={toggleEditMode}
                                style={{ borderColor: "#d9d9d9" }}
                                aria-label="Cancel Edit"
                            >
                                Cancel
                            </Button>
                        </div>
                    </center>

                )}

                {activeSection === "personal" && (
                    <>
                        <center><h2 className="mb-5">Personal Details</h2></center>

                        <div className="container px-4">
                            <div className="row gy-4">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Initial <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="initial" value={preOnboardData.initial || ""} onChange={handleChange} placeholder="Initial" disabled={!isEditMode} required />
                                        {errors.initial && <p style={{ color: 'red', fontSize: '12px' }}>{errors.initial}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>First Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="first_name" value={preOnboardData.first_name || ""} onChange={handleChange} placeholder="Name" disabled={!isEditMode} required />
                                        {errors.first_name && <p style={{ color: 'red', fontSize: '12px' }}>{errors.first_name}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Last Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="last_name" value={preOnboardData.last_name || ""} onChange={handleChange} placeholder="Name" disabled={!isEditMode} required />
                                        {errors.last_name && <p style={{ color: 'red', fontSize: '12px' }}>{errors.last_name}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Mobile Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="mobile_number" value={preOnboardData.mobile_number || ""} onChange={handleChange} placeholder="Mobile Number" disabled={!isEditMode} required />
                                        {errors.mobile_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mobile_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Email Id <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="email" name="email_id" value={preOnboardData.email_id || ""} onChange={handleChange} placeholder="Email Id" disabled={!isEditMode} required />
                                        {errors.email_id && <p style={{ color: 'red', fontSize: '12px' }}>{errors.email_id}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Aadhaar No <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="number" name="aadhaar_card_number" value={preOnboardData.aadhaar_card_number || ""} onChange={handleChange} placeholder="aadhaar_card_number No" disabled={!isEditMode} required />
                                        {errors.aadhaar_card_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.aadhaar_card_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>PAN No <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="pan_card_number" value={preOnboardData.pan_card_number || ""} onChange={handleChange} placeholder="pan_card_number number" disabled={!isEditMode} required />
                                        {errors.pan_card_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.pan_card_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Date Of Birth <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="date" name="date_of_birth" value={preOnboardData.date_of_birth || ""} onChange={handleChange} disabled={!isEditMode} required />
                                        {errors.date_of_birth && <p style={{ color: 'red', fontSize: '12px' }}>{errors.date_of_birth}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Place Of Birth <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="place_of_birth" value={preOnboardData.place_of_birth || ""} onChange={handleChange} placeholder="place of birth" disabled={!isEditMode} required />
                                        {errors.place_of_birth && <p style={{ color: 'red', fontSize: '12px' }}>{errors.place_of_birth}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Mother Tongue <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="mother_tongue" value={preOnboardData.mother_tongue || ""} onChange={handleChange} placeholder="Mother Tongue" disabled={!isEditMode} required />
                                        {errors.mother_tongue && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mother_tongue}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            Gender <span style={{ color: "#d32f2f" }}>*</span>
                                        </label>
                                        <select
                                            name="gender"
                                            value={preOnboardData.gender || ""}
                                            onChange={handleChange}
                                            disabled={!isEditMode}
                                            required
                                            style={{ width: "100%", padding: "8px" }}
                                        >
                                            <option value="">-- Select Gender --</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        {errors.gender && (
                                            <p style={{ color: "red", fontSize: "12px" }}>{errors.gender}</p>
                                        )}
                                    </div>

                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Religion</label>
                                        <input type="text" name="religion" value={preOnboardData.religion || ""} onChange={handleChange} placeholder="Religion" disabled={!isEditMode} />
                                        {errors.religion && <p style={{ color: 'red', fontSize: '12px' }}>{errors.religion}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Blood Group <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="blood_group" value={preOnboardData.blood_group || ""} onChange={handleChange} placeholder="Blood group" disabled={!isEditMode} required />
                                        {errors.blood_group && <p style={{ color: 'red', fontSize: '12px' }}>{errors.blood_group}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Height<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="height" value={preOnboardData.height || ""} onChange={handleChange} placeholder="Height" disabled={!isEditMode} required />
                                        {errors.height && <p style={{ color: 'red', fontSize: '12px' }}>{errors.height}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Weight<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="weight" value={preOnboardData.weight || ""} onChange={handleChange} placeholder="weight" disabled={!isEditMode} required />
                                        {errors.weight && <p style={{ color: 'red', fontSize: '12px' }}>{errors.weight}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Marital Status</label>
                                        <select name="marital_status" value={preOnboardData.marital_status || ""} onChange={handleChange} disabled={!isEditMode}>
                                            <option value="">Select Option</option>
                                            <option value="Married">Married</option>
                                            <option value="Unmarried">Unmarried</option>
                                        </select>
                                    </div>

                                    {preOnboardData.marital_status === "Married" && (
                                        <>
                                            <div className="form-group">
                                                <label>Wedding Date</label>
                                                <input type="date" name="wedding_date" value={preOnboardData.wedding_date || ""} onChange={handleChange} disabled={!isEditMode} />
                                            </div>

                                            <div className="form-group">
                                                <label>Spouse Name</label>
                                                <input type="text" name="spouse_name" value={preOnboardData.spouse_name || ""} onChange={handleChange} placeholder="Spouse Name" disabled={!isEditMode} />
                                            </div>

                                            <div className="form-group">
                                                <label>Spouse DOB</label>
                                                <input type="date" name="spouse_dob" value={preOnboardData.spouse_dob || ""} onChange={handleChange} disabled={!isEditMode} />
                                            </div>

                                            {/* Children Details Section */}
                                            <div style={{ marginTop: "20px" }}>
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <Typography.Title level={5}>Children Details</Typography.Title>
                                                    <Button
                                                        type="dashed"
                                                        icon={<PlusOutlined />}
                                                        onClick={() => {
                                                            const updatedChildDetails = Array.isArray(preOnboardData.child_details)
                                                                ? [...preOnboardData.child_details, { child_name: "", child_dob: "" }]
                                                                : [{ child_name: "", child_dob: "" }];
                                                            handleChange({
                                                                target: { name: "child_details", value: updatedChildDetails },
                                                            });
                                                        }}
                                                        disabled={!isEditMode}
                                                        aria-label="Add Child"
                                                    >
                                                        Add Child
                                                    </Button>
                                                </div>

                                                {Array.isArray(preOnboardData.child_details) && preOnboardData.child_details.length > 0 ? (
                                                    preOnboardData.child_details.map((child, index) => (
                                                        <Card key={index} className="mb-3">
                                                            <Space
                                                                align="start"
                                                                style={{ display: "flex", justifyContent: "space-between" }}
                                                            >
                                                                <Form layout="vertical" style={{ flex: 1 }}>
                                                                    <Form.Item label="Child Name">
                                                                        <Input
                                                                            value={child.child_name || ""}
                                                                            onChange={(e) => {
                                                                                const updatedChildDetails = Array.isArray(preOnboardData.child_details)
                                                                                    ? [...preOnboardData.child_details]
                                                                                    : [];
                                                                                updatedChildDetails[index] = {
                                                                                    ...updatedChildDetails[index],
                                                                                    child_name: e.target.value,
                                                                                };
                                                                                handleChange({
                                                                                    target: { name: "child_details", value: updatedChildDetails },
                                                                                });
                                                                            }}
                                                                            placeholder="Enter child name"
                                                                            disabled={!isEditMode}
                                                                        />
                                                                    </Form.Item>

                                                                    <Form.Item label="Child DOB">
                                                                        <DatePicker
                                                                            style={{ width: "100%" }}
                                                                            value={child.child_dob ? dayjs(child.child_dob) : null}
                                                                            onChange={(date, dateString) => {
                                                                                const updatedChildDetails = Array.isArray(preOnboardData.child_details)
                                                                                    ? [...preOnboardData.child_details]
                                                                                    : [];
                                                                                updatedChildDetails[index] = {
                                                                                    ...updatedChildDetails[index],
                                                                                    child_dob: dateString,
                                                                                };
                                                                                handleChange({
                                                                                    target: { name: "child_details", value: updatedChildDetails },
                                                                                });
                                                                            }}
                                                                            disabled={!isEditMode}
                                                                        />
                                                                    </Form.Item>
                                                                </Form>

                                                                <Button
                                                                    danger
                                                                    icon={<CloseOutlined />}
                                                                    onClick={() => {
                                                                        const updatedChildDetails = Array.isArray(preOnboardData.child_details)
                                                                            ? preOnboardData.child_details.filter((_, i) => i !== index)
                                                                            : [];
                                                                        handleChange({
                                                                            target: { name: "child_details", value: updatedChildDetails },
                                                                        });
                                                                    }}
                                                                    disabled={!isEditMode}
                                                                    aria-label="Delete Child"
                                                                />
                                                            </Space>
                                                        </Card>
                                                    ))
                                                ) : (
                                                    <p>No children details available.</p>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    <div className="form-group">
                                        <label>Emergency Contact Person <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="emergency_contact_person" value={preOnboardData.emergency_contact_person || ""} onChange={handleChange} placeholder="Contact Person" disabled={!isEditMode} required />
                                        {errors.emergency_contact_person && <p style={{ color: 'red', fontSize: '12px' }}>{errors.emergency_contact_person}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Emergency Contact Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="emergency_contact_number" value={preOnboardData.emergency_contact_number || ""} onChange={handleChange} placeholder="Contact Number" disabled={!isEditMode} required />
                                        {errors.emergency_contact_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.emergency_contact_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Father's Name</label>
                                        <input type="text" name="father_name" value={preOnboardData.father_name || ""} onChange={handleChange} placeholder="Father Name" disabled={!isEditMode} />
                                    </div>

                                    <div className="form-group">
                                        <label>Father's Profession</label>
                                        <input type="text" name="father_profession" value={preOnboardData.father_profession || ""} onChange={handleChange} placeholder="Father Profession" disabled={!isEditMode} />
                                    </div>

                                    <div className="form-group">
                                        <label>Mother's Name</label>
                                        <input type="text" name="mother_name" value={preOnboardData.mother_name || ""} onChange={handleChange} placeholder="Mother Name" disabled={!isEditMode} />
                                    </div>

                                    <div className="form-group">
                                        <label>Mother's Profession</label>
                                        <input type="text" name="mother_profession" value={preOnboardData.mother_profession || ""} onChange={handleChange} placeholder="Mother Profession" disabled={!isEditMode} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <center><button className="text-light p-2 py-1" onClick={() => setActiveSection("bank")}>Next</button></center>
                    </>
                )}

                {activeSection === "bank" && (
                    <>
                        <center><h2 className="mb-5">Bank Details</h2></center>
                        <center>
                            <div id="bank-area" className="container row px-4">
                                <div className="col-12 col-md-6 p-2">
                                    <div className="form-group">
                                        <label>Bank Account Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="bank_account_number"
                                            value={preOnboardData.bank_account_number || ""}
                                            onChange={handleChange}
                                            placeholder="Bank Account No"
                                            disabled={!isEditMode}
                                            required
                                        />
                                        {errors.bank_account_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.bank_account_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>IFSC Code <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="ifsc_code"
                                            value={preOnboardData.ifsc_code || ""}
                                            onChange={handleChange}
                                            placeholder="IFSC Code"
                                            disabled={!isEditMode}
                                            required
                                        />
                                        {errors.ifsc_code && <p style={{ color: 'red', fontSize: '12px' }}>{errors.ifsc_code}</p>}
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 p-2">
                                    <div className="form-group">
                                        <label>UAN Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="uan_number"
                                            value={preOnboardData.uan_number || ""}
                                            onChange={handleChange}
                                            placeholder="UAN no"
                                            disabled={!isEditMode}
                                            required
                                        />
                                        {errors.uan_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.uan_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Branch Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="branch_name"
                                            value={preOnboardData.branch_name || ""}
                                            onChange={handleChange}
                                            placeholder="Branch Name"
                                            disabled={!isEditMode}
                                            required
                                        />
                                        {errors.branch_name && <p style={{ color: 'red', fontSize: '12px' }}>{errors.branch_name}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                                <button className="text-light p-2 py-1" onClick={() => setActiveSection("personal")}>
                                    Previous
                                </button>
                                <button className="text-light p-2 py-1" onClick={() => setActiveSection("address")}>
                                    Next
                                </button>
                            </div>

                        </center>
                    </>
                )}

                {activeSection === "address" &&
                    (
                        <>
                            <center><h2 className="mb-5">Address Details</h2></center>
                            <center>
                                <div id="address-area" className="container row px-4">
                                    <div className="col-12 col-md-6 p-2">
                                        <div className="form-group">
                                            <label>Address <span style={{ color: "#d32f2f" }}>*</span></label>
                                            <textarea
                                                name="address_for_communication"
                                                className="form-control"
                                                value={preOnboardData.address_for_communication || ""}
                                                onChange={handleChange}
                                                disabled={!isEditMode}
                                                required
                                            ></textarea>
                                            {errors.address_for_communication && <p style={{ color: 'red', fontSize: '12px' }}>{errors.address_for_communication}</p>}
                                        </div>


                                        <div className="form-group">
                                            <label>Area <span style={{ color: "#d32f2f" }}>*</span></label>
                                            <input
                                                type="text"
                                                name="area"
                                                className="form-control"
                                                value={preOnboardData.area || ""}
                                                onChange={handleChange}
                                                disabled={!isEditMode}
                                                required
                                            />
                                            {errors.area && <p style={{ color: 'red', fontSize: '12px' }}>{errors.area}</p>}
                                        </div>

                                        <div className="form-group">
                                            <label>City <span style={{ color: "#d32f2f" }}>*</span></label>
                                            <input
                                                type="text"
                                                name="city"
                                                className="form-control"
                                                value={preOnboardData.city || ""}
                                                onChange={handleChange}
                                                disabled={!isEditMode}
                                                required
                                            />
                                            {errors.city && <p style={{ color: 'red', fontSize: '12px' }}>{errors.city}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 p-2">
                                        <div className="form-group">
                                            <label>State <span style={{ color: "#d32f2f" }}>*</span></label>
                                            <input
                                                type="text"
                                                name="state"
                                                className="form-control"
                                                value={preOnboardData.state || ""}
                                                onChange={handleChange}
                                                disabled={!isEditMode}
                                                required
                                            />
                                            {errors.state && <p style={{ color: 'red', fontSize: '12px' }}>{errors.state}</p>}
                                        </div>

                                        <div className="form-group">
                                            <label>Country <span style={{ color: "#d32f2f" }}>*</span></label>
                                            <input
                                                type="text"
                                                name="country"
                                                className="form-control"
                                                value={preOnboardData.country || ""}
                                                onChange={handleChange}
                                                disabled={!isEditMode}
                                                required
                                            />
                                            {errors.country && <p style={{ color: 'red', fontSize: '12px' }}>{errors.country}</p>}
                                        </div>

                                        <div className="form-group">
                                            <label>Pincode <span style={{ color: "#d32f2f" }}>*</span></label>
                                            <input
                                                type="number"
                                                name="pincode"
                                                className="form-control"
                                                value={preOnboardData.pincode || ""}
                                                onChange={handleChange}
                                                disabled={!isEditMode}
                                                required
                                            />
                                            {errors.pincode && <p style={{ color: 'red', fontSize: '12px' }}>{errors.pincode}</p>}
                                        </div>
                                    </div>

                                    <div>
                                        <label>Permanent Address</label>
                                        <input
                                            type="checkbox"
                                            name="permanent_address"
                                            checked={preOnboardData.permanent_address === "yes"}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setPreOnboardData((prev) => ({
                                                        ...prev,
                                                        permanent_address: "yes",
                                                        permanent_address_for_communication: prev.address_for_communication,
                                                        permanent_area: prev.area,
                                                        permanent_city: prev.city,
                                                        permanent_state: prev.state,
                                                        permanent_country: prev.country,
                                                        permanent_pincode: prev.pincode,
                                                    }));
                                                } else {
                                                    setPreOnboardData((prev) => ({
                                                        ...prev,
                                                        permanent_address: "no",
                                                        permanent_address_for_communication: "",
                                                        permanent_area: "",
                                                        permanent_city: "",
                                                        permanent_state: "",
                                                        permanent_country: "",
                                                        permanent_pincode: "",
                                                    }));
                                                }
                                            }}
                                            disabled={!isEditMode}
                                        />{" "}
                                        Yes
                                    </div>

                                    {/* Permanent Address */}
                                    <h5>Permanent Address</h5>
                                    <div id="address-area" className="container row px-4">
                                        <div className="col-12 col-md-6 p-2">
                                            <div className="form-group">
                                                <label>Address <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <textarea
                                                    name="permanent_address_for_communication"
                                                    className="form-control"
                                                    value={preOnboardData.permanent_address_for_communication || ""}
                                                    onChange={handleChange}
                                                    disabled={!isEditMode}
                                                    required
                                                ></textarea>
                                                {errors.permanent_address_for_communication && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_address_for_communication}</p>}
                                            </div>


                                            <div className="form-group">
                                                <label>Area<span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="permanent_area"
                                                    className="form-control"
                                                    value={preOnboardData.permanent_area || ""}
                                                    onChange={handleChange}
                                                    disabled={!isEditMode}
                                                    required
                                                />
                                                {errors.permanent_area && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_area}</p>}
                                            </div>

                                            <div className="form-group">
                                                <label>City<span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="permanent_city"
                                                    className="form-control"
                                                    value={preOnboardData.permanent_city || ""}
                                                    onChange={handleChange}
                                                    disabled={!isEditMode}
                                                    required
                                                />
                                                {errors.permanent_city && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_city}</p>}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-6 p-2">
                                            <div className="form-group">
                                                <label>State<span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="permanent_state"
                                                    className="form-control"
                                                    value={preOnboardData.permanent_state || ""}
                                                    onChange={handleChange}
                                                    disabled={!isEditMode}
                                                    required
                                                />
                                                {errors.permanent_state && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_state}</p>}
                                            </div>

                                            <div className="form-group">
                                                <label>Country<span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="permanent_country"
                                                    className="form-control"
                                                    value={preOnboardData.permanent_country || ""}
                                                    onChange={handleChange}
                                                    disabled={!isEditMode}
                                                    required
                                                />
                                                {errors.permanent_country && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_country}</p>}
                                            </div>

                                            <div className="form-group">
                                                <label>Pincode<span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="number"
                                                    name="permanent_pincode"
                                                    className="form-control"
                                                    value={preOnboardData.permanent_pincode || ""}
                                                    onChange={handleChange}
                                                    disabled={!isEditMode}
                                                    required
                                                />
                                                {errors.permanent_pincode && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_pincode}</p>}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                                    <button className="text-light p-1 py-1" style={{ background: "#0e497b", color: "#ffffffff" }} onClick={() => setActiveSection("bank")}>Previous</button>
                                    <button className="text-light p-1 py-1" style={{ background: "#0e497b", color: "#ffffffff" }} onClick={() => setActiveSection("education")}>Next</button>
                                </div>
                            </center>
                        </>
                    )}

                {activeSection === "education" && (
                    <div style={{ padding: "20px" }}>
                        <center>
                            <Title level={2}>Academic Details</Title>
                        </center>

                        <Row gutter={16} justify="center" className="mt-5">
                            {/* Education History */}
                            <Col xs={24} md={8}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <Title level={4}>Education History</Title>
                                    <Button
                                        type="dashed"
                                        icon={<PlusOutlined />}
                                        onClick={() => setAddEducation(addEducation + 1)}
                                        disabled={!isEditMode}
                                    >
                                        Add
                                    </Button>
                                </div>

                                {Array.from({ length: addEducation }, (_, index) => (
                                    <Card key={index} className="mb-3" bordered>
                                        <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                                            <Button
                                                type="dashed"
                                                icon={<PlusOutlined />}
                                                onClick={() => setAddEducation(addEducation + 1)}
                                                disabled={!isEditMode}
                                            />
                                            <Button
                                                danger
                                                icon={<CloseOutlined />}
                                                onClick={() => setAddEducation(addEducation - 1)}
                                                disabled={!isEditMode}
                                            />
                                        </Space>
                                        <Form layout="vertical">
                                            <Form.Item label="Educational Qualification" required>
                                                <Input
                                                    value={preOnboardData.education_history?.[index]?.educational_qualification || ""}
                                                    onChange={(e) =>
                                                        handleEducationChange(index, "educational_qualification", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Institution Name" required>
                                                <Input
                                                    value={preOnboardData.education_history?.[index]?.educational_institution_name || ""}
                                                    onChange={(e) =>
                                                        handleEducationChange(index, "educational_institution_name", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Degree / Diploma" required>
                                                <Input
                                                    value={preOnboardData.education_history?.[index]?.degree_or_diploma || ""}
                                                    onChange={(e) =>
                                                        handleEducationChange(index, "degree_or_diploma", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="From" required>
                                                <DatePicker
                                                    style={{ width: "100%" }}
                                                    value={preOnboardData.education_history?.[index]?.course_duration_from ? dayjs(preOnboardData.education_history?.[index]?.course_duration_from) : null}
                                                    onChange={(date, dateString) =>
                                                        handleEducationChange(index, "course_duration_from", dateString)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="To" required>
                                                <DatePicker
                                                    style={{ width: "100%" }}
                                                    value={preOnboardData.education_history?.[index]?.course_duration_to ? dayjs(preOnboardData.education_history?.[index]?.course_duration_to) : null}
                                                    onChange={(date, dateString) =>
                                                        handleEducationChange(index, "course_duration_to", dateString)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>

                                            <Form.Item label="Extra curricular Activities">
                                                <Input
                                                    value={preOnboardData.education_history?.[index]?.extra_curricular_activity || ""}
                                                    onChange={(e) => handleEducationChange(index, "extra_curricular_activity", e.target.value)}
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="others">
                                                <Input
                                                    value={preOnboardData.education_history?.[index]?.others || ""}
                                                    onChange={(e) => handleEducationChange(index, "others", e.target.value)}
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                ))}
                            </Col>

                            {/* Career History */}
                            <Col xs={24} md={8}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <Title level={4}>Career History</Title>
                                    <Button
                                        type="dashed"
                                        icon={<PlusOutlined />}
                                        onClick={() => setAddCareer(addCareer + 1)}
                                        disabled={!isEditMode}
                                    >
                                        Add
                                    </Button>
                                </div>

                                {Array.from({ length: addCareer }, (_, index) => (
                                    <Card key={index} className="mb-3" bordered>
                                        <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                                            <Button
                                                type="dashed"
                                                icon={<PlusOutlined />}
                                                onClick={() => setAddCareer(addCareer + 1)}
                                                disabled={!isEditMode}
                                            />
                                            <Button
                                                danger
                                                icon={<CloseOutlined />}
                                                onClick={() => setAddCareer(addCareer - 1)}
                                                disabled={!isEditMode}
                                            />
                                        </Space>
                                        <Form layout="vertical">
                                            <Form.Item label="Company Name" required>
                                                <Input
                                                    value={preOnboardData.career_history?.[index]?.organisation || ""}
                                                    onChange={(e) => handleCareerChange(index, "organisation", e.target.value)}
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Designation" required>
                                                <Input
                                                    value={preOnboardData.career_history?.[index]?.designation || ""}
                                                    onChange={(e) => handleCareerChange(index, "designation", e.target.value)}
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="From" required>
                                                <DatePicker
                                                    style={{ width: "100%" }}
                                                    value={preOnboardData.career_history?.[index]?.work_duration_from ? dayjs(preOnboardData.career_history?.[index]?.work_duration_from) : null}
                                                    onChange={(date, dateString) =>
                                                        handleCareerChange(index, "work_duration_from", dateString)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="To" required>
                                                <DatePicker
                                                    style={{ width: "100%" }}
                                                    value={preOnboardData.career_history?.[index]?.work_duration_to ? dayjs(preOnboardData.career_history?.[index]?.work_duration_to) : null}
                                                    onChange={(date, dateString) =>
                                                        handleCareerChange(index, "work_duration_to", dateString)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Key Responsibilities" required>
                                                <Input.TextArea
                                                    rows={2}
                                                    value={preOnboardData.career_history?.[index]?.keyresponsibilities || ""}
                                                    onChange={(e) =>
                                                        handleCareerChange(index, "keyresponsibilities", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                ))}
                            </Col>

                            {/* Reference History */}
                            <Col xs={24} md={8}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <Title level={4}>Reference History</Title>
                                    <Button
                                        type="dashed"
                                        icon={<PlusOutlined />}
                                        onClick={() => setAddReference(addReference + 1)}
                                        disabled={!isEditMode}
                                    >
                                        Add
                                    </Button>
                                </div>

                                {Array.from({ length: addReference }, (_, index) => (
                                    <Card key={index} className="mb-3" bordered>
                                        <Space className="mb-3" style={{ justifyContent: "flex-end", width: "100%" }}>
                                            <Button
                                                type="dashed"
                                                icon={<PlusOutlined />}
                                                onClick={() => setAddReference(addReference + 1)}
                                                disabled={!isEditMode}
                                            />
                                            <Button
                                                danger
                                                icon={<CloseOutlined />}
                                                onClick={() => setAddReference(addReference - 1)}
                                                disabled={!isEditMode}
                                            />
                                        </Space>
                                        <Form layout="vertical">
                                            <Form.Item label="Reference Name" required>
                                                <Input
                                                    value={preOnboardData.reference_history?.[index]?.referal_name || ""}
                                                    onChange={(e) => handleReferenceChange(index, "referal_name", e.target.value)}
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Reference Designation" required>
                                                <Input
                                                    value={preOnboardData.reference_history?.[index]?.referal_desgination || ""}
                                                    onChange={(e) =>
                                                        handleReferenceChange(index, "referal_desgination", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Reference Mobile" required>
                                                <Input
                                                    value={preOnboardData.reference_history?.[index]?.referal_mobile_number || ""}
                                                    onChange={(e) =>
                                                        handleReferenceChange(index, "referal_mobile_number", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                            <Form.Item label="Reference Email Id" required>
                                                <Input
                                                    value={preOnboardData.reference_history?.[index]?.referal_email_id || ""}
                                                    onChange={(e) =>
                                                        handleReferenceChange(index, "referal_email_id", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                ))}
                            </Col>

                            {/* <Col xs={24} md={8}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <Title level={4}>Extra Curricular Activities</Title>
                                    <Button
                                        type="dashed"
                                        icon={<PlusOutlined />}
                                        onClick={() => setAddActivity(addActivity + 1)}
                                        disabled={!isEditMode}
                                    >
                                        Add
                                    </Button>
                                </div>

                                {Array.from({ length: addActivity }, (_, index) => (
                                    <Card key={index} className="mb-3" bordered>
                                        <Space
                                            className="mb-3"
                                            style={{ justifyContent: "flex-end", width: "100%" }}
                                        >
                                            <Button
                                                type="dashed"
                                                icon={<PlusOutlined />}
                                                onClick={() => setAddActivity(addActivity + 1)}
                                                disabled={!isEditMode}
                                            />
                                            <Button
                                                danger
                                                icon={<CloseOutlined />}
                                                onClick={() => setAddActivity(addActivity - 1)}
                                                disabled={!isEditMode}
                                            />
                                        </Space>
                                        <Form layout="vertical">
                                            <Form.Item label="Activity Name" required>
                                                <Input
                                                    value={
                                                        preOnboardData.extra_curricular_activity?.[index]?.activity_name || ""
                                                    }
                                                    onChange={(e) =>
                                                        handleActivityChange(index, "activity_name", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>

                                            <Form.Item label="Description" required>
                                                <Input.TextArea
                                                    rows={2}
                                                    value={
                                                        preOnboardData.extra_curricular_activity?.[index]?.activity_description || ""
                                                    }
                                                    onChange={(e) =>
                                                        handleActivityChange(index, "activity_description", e.target.value)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>

                                            <Form.Item label="Year / Duration" required>
                                                <DatePicker
                                                    picker="year"
                                                    style={{ width: "100%" }}
                                                    value={preOnboardData.extra_curricular_activity?.[index]?.activity_year ? dayjs(preOnboardData.extra_curricular_activity?.[index]?.activity_year) : null}
                                                    onChange={(date, dateString) =>
                                                        handleActivityChange(index, "activity_year", dateString)
                                                    }
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                ))}
                            </Col> */}

                        </Row>

                        <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                            <button className="text-light p-1 py-1" style={{ background: "#0e497b", color: "#ffffffff" }} onClick={() => setActiveSection("address")}>Previous</button>
                            <button className="text-light p-1 py-1" style={{ background: "#0e497b", color: "#ffffffff" }} onClick={() => setActiveSection("documents")}>Next</button>
                        </div>
                    </div>
                )}

            </div>
            {activeSection === "documents" && preOnboardData && (
                <>
                    <center>
                        <h2 className="mb-3">Onboard Documents</h2>
                    </center>

                    <div className="container d-flex flex-wrap justify-content-between mt-4 px-2">
                        {/* Left Column: Personal Details */}
                        <div className="p-4 col-12 col-md-4">
                            <h5 className="mt-2">Personal Documents</h5>

                            {preOnboardData.aadhar_card_copy && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.aadhar_card_copy)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Aadhaar Card</span>
                                </div>
                            )}

                            {preOnboardData.bank_account_details && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.bank_account_details)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Bank Details</span>
                                </div>
                            )}
                            {preOnboardData.pan_card_copy && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.pan_card_copy)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Pan Card</span>
                                </div>
                            )}
                            {preOnboardData.covid_certificate && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.covid_certificate)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Covid Certificate</span>
                                </div>
                            )}
                        </div>

                        {/* Middle Column: Educational Documents */}
                        <div className="p-4 col-12 col-md-4">
                            <h5 className="mt-2">Educational Documents</h5>

                            {preOnboardData.SSLC && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.SSLC)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>SSLC</span>
                                </div>
                            )}

                            {preOnboardData.HSC_diploma_ITI && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.HSC_diploma_ITI)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>HSC / Diploma / ITI</span>
                                </div>
                            )}

                            {preOnboardData.PG_Phd && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.PG_Phd)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>PG / PhD</span>
                                </div>
                            )}

                            {preOnboardData.degree_certificate && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.degree_certificate)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Degree Certificate</span>
                                </div>
                            )}
                        </div>

                        {/* Right Column: Employment Documents */}
                        <div className="p-4 col-12 col-md-4">
                            <h5 className="mt-2">Employment Documents</h5>

                            {preOnboardData.previous_experience_letter && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.previous_experience_letter)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Experience Letter</span>
                                </div>
                            )}
                            {preOnboardData.last_three_month_payslip && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.last_three_month_payslip)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Three Months Payslip</span>
                                </div>
                            )}
                            {preOnboardData.last_three_months_account_statement && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.last_three_months_account_statement)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Three Months Account Statement</span>
                                </div>
                            )}
                            {preOnboardData.releiving_letter && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.releiving_letter)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Releiving Letter</span>
                                </div>
                            )}
                            {preOnboardData.offer_letter && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.offer_letter)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Offer Letter</span>
                                </div>
                            )}

                            {preOnboardData.appointment_letter && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.appointment_letter)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Appointment Letter</span>
                                </div>
                            )}

                            {preOnboardData.bank_account_details && (
                                <div
                                    className="mb-3 d-flex align-items-center cursor-pointer"
                                    onClick={() => handleOpen(preOnboardData.bank_account_details)}
                                >
                                    <FaFilePdf className="me-2 text-danger" />
                                    <span>Bank Account Details</span>
                                </div>
                            )}
                        </div>
                    </div>
                </>)
            }

            {/* {isEditMode && (
                <center>
                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
                        <Button
                            onClick={saveChanges}
                            loading={isSubmitting}
                            style={{ background: "#0e497b", color: "#ffffffff" }}
                            aria-label="Save Changes"
                        >
                            Save
                        </Button>
                        <Button
                            onClick={toggleEditMode}
                            style={{ borderColor: "#d9d9d9" }}
                            aria-label="Cancel Edit"
                        >
                            Cancel
                        </Button>
                    </div>
                </center>

            )}
            {!isEditMode && (
                <center>
                    <Button
                        className="mt-3"
                        onClick={toggleEditMode}
                        style={{ background: "#0e497b", color: "#ffffffff" }}
                        aria-label="Edit Profile"
                    >
                        Edit
                    </Button>
                </center>

            )} */}

            {docType === "image" && (
                <Modal
                    open={showModal}
                    onCancel={() => setShowModal(false)}
                    footer={null}
                    width={800}
                    centered
                    title="Document Preview"
                    aria-label="Document Preview Modal"
                >
                    <img
                        src={docUrl}
                        alt="Document Preview"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </Modal>
            )}



            {authData.employee.is_superuser ? (
                <center>
                    {
                        preOnboardData.hr_candidate_conversion === "Rejected" ? (
                            <p style={{ color: "#e11c1cff", fontWeight: "bold", marginTop: '10px' }}>
                                Profile Already Rejected!
                            </p>
                        ) : preOnboardData.hr_candidate_conversion === "Approved" ? (
                            <>
                                <p style={{ color: "#57e11cff", fontWeight: "bold", marginTop: '10px' }}>
                                    Profile Already Verified!
                                </p>
                                <Button
                                    danger
                                    icon={<StopOutlined />}
                                    onClick={() => {
                                        handleBlockList(candidateid)

                                        console.log("Preonborad id : ", candidateid)
                                    }}
                                >
                                    Blocklist
                                </Button>
                                <TextArea
                                    name="blockRemarks"
                                    value={blockListReason}
                                    onChange={(e) => setBlockListReason(e.target.value)}
                                    rows={4}
                                    placeholder="Enter remarks"
                                    style={{ marginTop: 8 }}
                                />
                            </>

                        ) : (
                            <>
                                {preOnboardData?.document_verified_by && (
                                    <>
                                        <p style={{ color: "#57e11cff", fontWeight: "bold", marginTop: '10px' }}>
                                            Document Verified by {preOnboardData?.document_verified_by}
                                        </p>
                                        <p style={{ color: "rgb(0, 0, 0)", marginTop: '10px' }}>
                                            Remarks : {preOnboardData?.onboard_hr_remarks}
                                        </p>
                                    </>
                                )}
                                <Divider />
                                < div style={{ marginTop: "20px", width: '500px' }}>
                                    <Input.TextArea
                                        name="hr_candidate_remarks"
                                        value={onboardRemarks}
                                        onChange={(e) => setOnboardRemarks(e.target.value)}
                                        placeholder="Enter remarks"
                                        rows={4}
                                        style={{ width: "100%", marginBottom: "10px" }}
                                        aria-label="HR Candidate Remarks"
                                    />

                                    <Button
                                        type="primary"
                                        onClick={async () => {
                                            try {
                                                const formData = new FormData();
                                                formData.append("hr_candidate_remarks", onboardRemarks);
                                                formData.append("hr_approve_status", true);
                                                formData.append("hr_candidate_conversion", "Approved")
                                                await axios.post(
                                                    `${backUrl}/api/emp/candidate/${effectiveCandidateId}/hr-approve/`,
                                                    formData,
                                                    {
                                                        headers: {
                                                            Authorization: `Bearer ${authData?.access}`,
                                                            "Content-Type": "multipart/form-data",
                                                        },
                                                    }
                                                );
                                                toast.success("Profile Verified Successfully");
                                                setOnboardRemarks("");
                                                fetchCandidateData();
                                            } catch (err) {
                                                console.error("Error verifying profile:", err);

                                                // If backend sent validation errors
                                                if (err.response && err.response.data) {
                                                    const errors = err.response.data;

                                                    // Join all error messages into a single string
                                                    const errorMsg = Object.values(errors)
                                                        .flat()
                                                        .join(", ");

                                                    toast.error(errorMsg || "Failed to verify profile");
                                                } else {
                                                    // Fallback if no response data
                                                    toast.error("Failed to verify profile");
                                                }
                                            }

                                        }}
                                        style={{ margin: "10px", background: "#0e497b", borderColor: "#ffffffff" }}
                                        aria-label="Verify Profile"
                                    >
                                        Verified
                                    </Button>
                                    <Button
                                        danger
                                        onClick={async () => {
                                            try {
                                                const formData = new FormData();
                                                formData.append("hr_candidate_remarks", onboardRemarks);
                                                formData.append("hr_approve_status", false);
                                                formData.append("hr_candidate_conversion", "Rejected")

                                                await axios.post(
                                                    `${backUrl}/api/emp/candidate/${effectiveCandidateId}/hr-approve/`,
                                                    formData,
                                                    {
                                                        headers: {
                                                            Authorization: `Bearer ${authData?.access}`,
                                                            "Content-Type": "multipart/form-data",
                                                        },
                                                    }
                                                );
                                                toast.error("Profile Rejected");
                                                setOnboardRemarks("");
                                                fetchCandidateData();
                                            } catch (err) {
                                                console.error("Error verifying profile:", err);

                                                // If backend sent validation errors
                                                if (err.response && err.response.data) {
                                                    const errors = err.response.data;

                                                    // Join all error messages into a single string
                                                    const errorMsg = Object.values(errors)
                                                        .flat()
                                                        .join(", ");

                                                    toast.error(errorMsg || "Failed to verify profile");
                                                } else {
                                                    // Fallback if no response data
                                                    toast.error("Failed to verify profile");
                                                }
                                            }

                                        }}
                                        style={{ margin: "10px", background: "#ff4d4f", color: "#f2f2f2ff" }}
                                        aria-label="Reject Profile"
                                    >
                                        Rejected
                                    </Button>
                                </div>
                            </>

                        )
                    }

                </center >

            ) : (
                <>
                    {authData.employee.role === 1 && (
                        <>
                            {preOnboardData.document_verified_by ? (
                                <center>
                                    {
                                        preOnboardData.background_verification_status === "Rejected" ? (
                                            <p style={{ color: "#e11c1cff", fontWeight: "bold", marginTop: '10px' }}>
                                                Profile Already Rejected!
                                            </p>
                                        ) : (
                                            <>
                                                <p style={{ color: "#57e11cff", fontWeight: "bold", marginTop: '10px' }}>
                                                    Profile Already Verified!
                                                </p>
                                                <Button
                                                    danger
                                                    icon={<StopOutlined />}
                                                    onClick={() => handleBlockList(candidateid)}
                                                >
                                                    Blocklist
                                                </Button>
                                                <TextArea
                                                    name="blockRemarks"
                                                    value={blockListReason}
                                                    onChange={(e) => setBlockListReason(e.target.value)}
                                                    rows={4}
                                                    placeholder="Enter remarks"
                                                    style={{ marginTop: 8 }}
                                                />
                                            </>
                                        )
                                    }

                                </center>

                            ) : (
                                <center>
                                    <div style={{ marginTop: "20px", width: '500px' }}>
                                        <Input.TextArea
                                            name="onboard_hr_remarks"
                                            value={onboardRemarks}
                                            onChange={(e) => setOnboardRemarks(e.target.value)}
                                            placeholder="Enter remarks"
                                            rows={4}
                                            style={{ width: "100%", marginBottom: "10px" }}
                                            aria-label="HR Remarks"
                                        />
                                        <Button
                                            type="primary"
                                            onClick={async () => {
                                                try {
                                                    const formData = new FormData();
                                                    formData.append("onboard_hr_remarks", onboardRemarks);
                                                    formData.append("background_verification_status", "Approved");
                                                    formData.append("is_hr_view", "True");
                                                    await axios.put(
                                                        `${backUrl}/api/emp/candidate/${effectiveCandidateId}/update-background-status/`,
                                                        formData,
                                                        {
                                                            headers: {
                                                                Authorization: `Bearer ${authData?.access}`,
                                                                "Content-Type": "multipart/form-data",
                                                            },
                                                        }
                                                    );
                                                    toast.success("Profile Verified Successfully");
                                                    setOnboardRemarks("");
                                                    fetchCandidateData();
                                                } catch (err) {
                                                    console.error("Error verifying profile:", err);

                                                    // If backend sent validation errors
                                                    if (err.response && err.response.data) {
                                                        const errors = err.response.data;

                                                        // Join all error messages into a single string
                                                        const errorMsg = Object.values(errors)
                                                            .flat()
                                                            .join(", ");

                                                        toast.error(errorMsg || "Failed to verify profile");
                                                    } else {
                                                        // Fallback if no response data
                                                        toast.error("Failed to verify profile");
                                                    }
                                                }

                                            }}
                                            style={{ margin: "10px", background: "#0e497b", color: "white" }}
                                            aria-label="Verify Profile"
                                        >
                                            Profile Verified
                                        </Button>
                                        <Button
                                            danger
                                            onClick={async () => {
                                                try {
                                                    const formData = new FormData();
                                                    formData.append("onboard_hr_remarks", onboardRemarks);
                                                    formData.append("background_verification_status", "Rejected");
                                                    formData.append("is_hr_view", "False");
                                                    await axios.put(
                                                        `${backUrl}/api/emp/candidate/${effectiveCandidateId}/update-background-status/`,
                                                        formData,
                                                        {
                                                            headers: {
                                                                Authorization: `Bearer ${authData?.access}`,
                                                                "Content-Type": "multipart/form-data",
                                                            },
                                                        }
                                                    );
                                                    toast.error("Profile Rejected ");
                                                    setOnboardRemarks("");
                                                    fetchCandidateData();
                                                } catch (err) {
                                                    console.error("Error verifying profile:", err);

                                                    // If backend sent validation errors
                                                    if (err.response && err.response.data) {
                                                        const errors = err.response.data;

                                                        // Join all error messages into a single string
                                                        const errorMsg = Object.values(errors)
                                                            .flat()
                                                            .join(", ");

                                                        toast.error(errorMsg || "Failed to verify profile");
                                                    } else {
                                                        // Fallback if no response data
                                                        toast.error("Failed to verify profile");
                                                    }
                                                }
                                            }}
                                            style={{ margin: "10px", background: "#ff4d4f", color: "#ffffffff" }}
                                            aria-label="Reject Profile"
                                        >
                                            Profile Rejected
                                        </Button>
                                    </div>
                                </center>

                            )}
                        </>
                    )}
                    {authData.employee.role === 2 && (
                        <>
                            {preOnboardData?.hr_candidate_remarks && (
                                <>
                                    <p style={{ color: "rgb(122, 237, 111)", marginTop: '10px' }}>
                                        Remarks : {preOnboardData?.hr_candidate_conversion}
                                    </p>
                                    <p style={{ color: "rgb(0, 0, 0)", marginTop: '10px' }}>
                                        Remarks : {preOnboardData?.hr_candidate_remarks}
                                    </p>
                                </>
                            )}
                            {preOnboardData.convert_to_employee ? (
                                <>

                                    <p style={{ color: "#57e11cff", fontWeight: "bold", marginTop: '10px' }}>
                                        Candidate Already Converted
                                    </p>
                                    <Button
                                        danger
                                        icon={<StopOutlined />}
                                        onClick={() => {
                                            handleBlockList(candidateid)

                                            console.log("Preonborad id : ", candidateid)
                                        }}
                                    >
                                        Blocklist
                                    </Button>
                                    <TextArea
                                        name="blockRemarks"
                                        value={blockListReason}
                                        onChange={(e) => setBlockListReason(e.target.value)}
                                        rows={4}
                                        placeholder="Enter remarks"
                                        style={{ marginTop: 8 }}
                                    />
                                </>
                            ) : (
                                <ConvertEmployee
                                    candidateid={effectiveCandidateId}
                                    authData={authData}
                                    backUrl={backUrl}
                                />
                            )}
                        </>
                    )}



                </>
            )
            }

            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

export default ViewProfile;